export default __webpack_public_path__ + "static/media/people2.526ee1a1.svg";